import React, { useState } from "react";
import { Col, Menu, Row, Image, Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import investigation from "../../../assets/images/menuImages/investigation.svg";
import patients from "../../../assets/images/menuImages/patients.svg";
import allPAtients from "../../../assets/images/menuImages/users.svg";
import activeAllPatientsIcon from "../../../assets/images/menuImages/activeUserIcon.svg";
import users from "../../../assets/images/menuImages/usersImg.svg";
import activeUserIcon from "../../../assets/images/menuImages/usersImgActive.svg";
import patientsActive from "../../../assets/images/menuImages/patientsActive.svg";
import investigationActive from "../../../assets/images/menuImages/investigationActive.svg";
import appointmentActive from "../../../assets/images/menuImages/appointmentActive.svg";
import appointment from "../../../assets/images/menuImages/appointment.svg";
import billingopIcon from "../../../assets/receptionistIcons/billingopIcon.svg";
import activeBill from "../../../assets/receptionistIcons/activeBill.svg";
import partnerActive from "../../../assets/images/patientIcons/Partner onboardingActive.svg";
import partnerInActive from "../../../assets/images/patientIcons/Partner onboarding.svg";
import outpatient from "../../../assets/images/menuImages/outpatient.svg";
import outpatientActive from "../../../assets/images/menuImages/outpatientActive.svg";
import services from "../../../assets/images/menuImages/services.svg";
import activeServices from "../../../assets/images/menuImages/servicesActive.svg";
import dashboardIcon from "../../../assets/images/menuImages/dashboardRecep.svg";
import homeActive from "../../../assets/images/menuImages/homeActive.svg";

import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID, Role } from "../../../constants/defaultKeys";
import { useContext } from "react";

const ReceptionistSideMenu = ({ collapsed }) => {
  const router = useParams();
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const selectedFacility =
    Number(getCookie(FacilityID)) || userDetails?.currFacility;

  const activeRoleObj = userDetails?.activeOrg?.roles?.find(
    (r) => r.role === defaultRole && r.facility_id === Number(selectedFacility)
  );

  const ipAvailable = Boolean(activeRoleObj?.ip_available);
  const opAvailable = Boolean(activeRoleObj?.op_available);

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const menuImages = (icon) => {
    return (
      <span
        role="img"
        aria-label="user"
        class="anticon anticon-user ant-menu-item-icon"
      >
        <Image
          src={icon}
          preview={false}
          style={{ height: "20px", width: "auto", marginBottom: "8px" }}
        />
      </span>
    );
  };

  const items = [
    getItem(
      "Dashboard",
      "dashboard",
      router?.tab === "dashboard"
        ? menuImages(homeActive)
        : menuImages(dashboardIcon)
    ),
    // Always visible
    getItem(
      "All Patients",
      "home",
      router?.tab === "home"
        ? menuImages(activeAllPatientsIcon)
        : menuImages(allPAtients)
    ),

    // Show ONLY if IP is available
    ipAvailable &&
      getItem(
        "In Patients",
        "in-patients",
        router?.tab === "in-patients"
          ? menuImages(patientsActive)
          : menuImages(patients)
      ),

    // Show ONLY if OP is available
    opAvailable &&
      getItem(
        "Out Patients",
        "out-patients",
        router?.tab === "out-patients"
          ? menuImages(outpatientActive)
          : menuImages(outpatient)
      ),

    getItem(
      "Investigations",
      "investigation",
      router?.tab === "investigation"
        ? menuImages(investigationActive)
        : menuImages(investigation)
    ),

    getItem(
      "Appointments",
      "appointments",
      router?.tab === "appointments"
        ? menuImages(appointmentActive)
        : menuImages(appointment)
    ),

    getItem(
      "Billing",
      "billing",
      router?.tab === "billing"
        ? menuImages(activeBill)
        : menuImages(billingopIcon)
    ),
     getItem(
  "Services & Packages",
  "services",
  router?.tab === "services"
    ? menuImages(activeServices)
    : menuImages(services)
),

        getItem(
      "Users",
      "users",
      router?.tab === "users" ? menuImages(activeUserIcon) : menuImages(users)
    ),

    ipAvailable &&
      getItem(
        "Partner Onboarding",
        "partner_onboarding",
        router?.tab === "partner_onboarding"
          ? menuImages(partnerActive)
          : menuImages(partnerInActive)
      ),
  ].filter(Boolean); // 🔥 IMPORTANT

  const onClick = (e) => {
    let path;

    switch (e.key) {
      case "in-patients":
        path = `/receptionist/${e.key}?status=active`;
        break;
      case "users":
        path = `/receptionist/${e.key}`;
        break;

      case "medication":
        path = `/receptionist/${e.key}`;
        break;
      case "services":
        path = `/receptionist/services?type=services`;
        break;

      default:
        path = `/receptionist/${e.key}`;
    }

    navigate(path);
  };
  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Menu
          style={{ border: 0 }}
          onClick={onClick}
          selectedKeys={[router?.tab]}
          defaultSelectedKeys={[router?.tab]}
          inlineCollapsed={collapsed}
          items={items}
        />
      </Col>
    </Row>
  );
};

export default ReceptionistSideMenu;
